import { render, staticRenderFns } from "./daochu_jd.vue?vue&type=template&id=dd3148a2&scoped=true&"
import script from "./daochu_jd.vue?vue&type=script&lang=js&"
export * from "./daochu_jd.vue?vue&type=script&lang=js&"
import style0 from "./daochu_jd.vue?vue&type=style&index=0&id=dd3148a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd3148a2",
  null
  
)

export default component.exports